import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, BrowserRouter, Outlet } from "react-router-dom";

import Login from "./pages/Login";
import NextPage from "./components/NextPage";
import Dashboard from "./components/dashboard/Dashboard";
import VerificationCode from "./pages/VerificatonCode";
import ResetPassword from "./pages/ResetPasssword";
import Patient from "./pages/Patient";

import PrivateRoute from "./PrivateRoute";
import ConsultationForm from "./pages/ConsultationForm";
import Consultation from "./pages/Consultation";

import PatientForm from "./pages/PatientForm";
import BedTransfer from "./pages/BedTransfer";

import Appointments from "./pages/Appointments";
import AppointmentsAdd from "./pages/AppointmentsAdd.jsx";

import User from "./pages/User.jsx";
import UserAdd from "./pages/UserAdd.jsx";
import UserUnitRoleChange from "./pages/UserUnitRoleChange.jsx";

import Settings from "./pages/Settings";
import Reports from "./pages/Reports";
import ReportsList from "./pages/ReportsList";
import Nursing from "./pages/Nursing";
import Packages from "./pages/Packages";
import PackageDetails from "./pages/PackageDetails";
import AddPackage from "./pages/AddPackage";
import PatientInfo from "./pages/PatientInfo";
import FloatingIcon from "./comps/FloatingIcon";
import RadiologyIPD from "./pages/Radiology.jsx";
import RadiologyPatientAccept from "./pages/RadiologyPatientAccept";
import AddRelief from "./pages/AddRelief";
import MasterItem from "./pages/MasterItem";
import MasterUnit from "./pages/MasterUnit";
import MasterSubCategory from "./pages/MasterSubCategory";
import MasterBedSubCategory from "./pages/MasterBedSubCategory";
import Master from "./pages/Master";
import MasterDepartment from "./pages/MasterDepartment";
import MasterCategory from "./pages/MasterCategory";
import MasterWard from "./pages/MasterWard";
import MasterBedCategory from "./pages/MasterBedCategory";
import MasterVisitType from "./pages/MasterVisitType";
import MasterCompany from "./pages/MasterCompany";
import MasterSupplier from "./pages/MasterSupplier";
import MasterSupplierAdd from "./pages/MasterSupplierAdd";
import MasterBedNumberOne from "./pages/MasterBedNumberOne";
import MasterBedNumberTwo from "./pages/MasterBedNumberTwo";
import MasterItemAdd from "./pages/MasterItemAdd";
import MasterSharing from "./pages/MasterSharing";
import MasterSharingAdd from "./pages/MasterSharingAdd";
import MasterSharingHospitalReport from "./pages/MasterSharingHospitalReport";
import EditSharingTemplate from "./pages/EditSharingTemplate";
import Store from "./pages/Store";
import StoreAddStock from "./pages/StoreAddStock";
import MasterContract from "./pages/MasterContract";
import MasterContractAdd from "./pages/MasterContractAdd";
import MasterPolicy from "./pages/MasterPolicy";
import MasterPolicyAdd from "./pages/MasterPolicyAdd";
import MasterRelief from "./pages/MasterRelief";
import MasterReliefAdd from "./pages/MasterReliefAdd";
import MasterCountry from "./pages/MasterCountry";
import MasterState from "./pages/MasterState";
import MasterCity from "./pages/MasterCity";
import MasterRelationship from "./pages/MasterRelationship";
import MasterBloodGroup from "./pages/MasterBloodGroup";
import MasterDoctorReference from "./pages/MasterDoctorReference";
import Pathology from "./pages/Pathology";
import PathologyPatientProgress from "./pages/PathologyPatientProgress";
import PathologyAddReport from "./pages/PathologyAddReport";
import PathologyDrApproval from "./pages/PathologyDrApproval";
import NursingApprovals from "./pages/NursingApprovals";
import NursingBedHistory from "./pages/NursingBedHistory";
import NursingUnitTransferHistory from "./pages/NursingUnitTransferHistory";
import NursingAllMedicationTracking from "./pages/NursingAllMedicationTracking.jsx";
import NursingDischargeSummary from "./pages/NursingDischargeSummary.jsx";
import Pharmacy from "./pages/Pharmacy.jsx";
import PharmacyMedicineRequest from "./pages/PharmacyMedicineRequest.jsx";
import PharmacyMedicineReturn from "./pages/PharmacyMedicineReturn.jsx";
import PharmacyOutsider from "./pages/PharmacyOutsider.jsx";
import PharmacyOutsiderReopen from "./pages/PharmacyOutsiderReopen.jsx";
import Billing from "./pages/Billing.jsx";
import BillingList from "./pages/BillingList.jsx";
import MasterTransactionType from "./pages/MasterTransactionType.jsx";
import AppointmentsRescheduleCancel from "./pages/Appointments-Reschedule-Cancel.jsx";
import ConsultationAddService from "./pages/ConsultationAddService.jsx";
import ReportsCashCollection from "./pages/ReportsCashCollection.jsx";
import ReportsSummaryOfBill from "./pages/ReportsSummaryOfBill.jsx";
import MasterAdminProfileEdit from "./pages/MasterAdminProfileEdit.jsx";
import MasterRole from "./pages/MasterRole.jsx";
import MasterDynamicTemplate from "./pages/MasterDynamicTemplate.jsx";
import MasterAddDynamicTemplate from "./pages/MasterAddDynamicTemplate.jsx";
import MasterDynamicTemplateSettings from "./pages/MasterDynamicTemplateSettings.jsx";
import MasterDynamicTemplateSettingsNumericField from "./pages/MasterDynamicTemplateSettingsNumericField.jsx";
import ReportsExpense from "./pages/ReportsExpense.jsx";
import ReportsExpenseDetailStatement from "./pages/ReportsExpenseDetailStatement.jsx";
import ReportsPatientAdvancePayment from "./pages/ReportsPatientAdvancePayment.jsx";
import ReportsPackageCountSTatementIPD from "./pages/ReportsPackageCountSTatementIPD.jsx";
import ReportsIPDDischargePatient from "./pages/ReportsIPDDischargePatient.jsx";
import ReportsIPDPatientSummary from "./pages/ReportsIPDPatientSummary.jsx";
import ReportsPatientIndentLedger from "./pages/ReportsPatientIndentLedger.jsx";
import ReportsPatientIndentLedgerReturn from "./pages/ReportsPatientIndentLedgerReturn.jsx";
import ReportsPatientWardIssue from "./pages/ReportsPatientWardIssue.jsx";
import ReportsCancelPayment from "./pages/ReportsCancelPayment.jsx";
import ReportsCollection from "./pages/ReportsCollection.jsx";
import ReportsBillDetail from "./pages/ReportsBillDetail.jsx";
import ReportsBedOccupancy from "./pages/ReportsBedOccupancy.jsx";
import ReportsFinanceDashboard from "./pages/ReportsFinanceDashboard.jsx";
import MasterPackage from "./pages/MasterPackage.jsx";
import MasterPackageEdit from "./pages/MasterPackageEdit.jsx";
import PatientConvertConsultationOPD from "./pages/PatientConvertConsultationOPD.jsx";
import NursingMedicineReturn from "./pages/NursingMedicineReturn.jsx";
import NursingRequestTracking from "./pages/NursingRequestTracking.jsx";
import Radiology from "./pages/Radiology.jsx";

const App = () => {
  const ProtectedLayout = () => (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  );

  return (
    <BrowserRouter>
      <Routes>
        {/* Auth */}
        <Route path="/" element={<Login />} />

        <Route path="/next" element={<NextPage />} />
        <Route path="/verification" element={<VerificationCode />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route element={<ProtectedLayout />}>
          {/* Dashboard */}
          <Route exact path="/home" element={<Dashboard />} />

          {/* Consultation */}
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/consultation/:patientId" element={<ConsultationForm />} />
          <Route
            path="/consultation/:patientId/add-service"
            element={<ConsultationAddService />}
          />

          {/* Patients */}
          <Route path="/patient" element={<Patient />} />
          <Route path="/patient/form" element={<PatientForm />} />
          <Route path="/patient/info/:patientId?" element={<PatientInfo />} />
          <Route path="/patient/bed-transfer" element={<BedTransfer />} />
          <Route path="/patient/form/:patientId?" element={<PatientForm />} />
          <Route path="/patient/packages" element={<Packages />} />
          <Route path="/patient/packages/details" element={<PackageDetails />} />
          <Route path="/patient/packages/details/add" element={<AddPackage />} />
          <Route
            path="/patient/convert-consultation-opd/:id"
            element={<PatientConvertConsultationOPD />}
          />

          {/* appointments */}

          <Route path="/appointments" element={<Appointments />} />
          <Route path="/appointments/:patientId" element={<AppointmentsAdd />} />
          <Route
            path="/appointments/:id/:type"
            element={<AppointmentsRescheduleCancel />}
          />

          {/* Nursing */}

          <Route path="/nursing" element={<Nursing />} />
          <Route
            path="/nursing/medicine-requests-tracking/:patientId/:visitId"
            element={<NursingRequestTracking />}
          />
          <Route
            path="/nursing/all-medicine-trackings"
            element={<NursingAllMedicationTracking />}
          />
          <Route
            path="/nursing/medicine-return/:patientId/:visitId"
            element={<NursingMedicineReturn />}
          />
          <Route path="/nursing/approvals" element={<NursingApprovals />} />
          <Route
            path="/nursing/bed-history/:visitId"
            element={<NursingBedHistory />}
          />
          <Route
            path="/nursing/unit-transfer-history/:visitId"
            element={<NursingUnitTransferHistory />}
          />
          <Route
            path="/nursing/discharge-summary/:visitId"
            element={<NursingDischargeSummary />}
          />

          {/* Store */}

          <Route path="/store" element={<Store />} />
          <Route path="/store/add" element={<StoreAddStock />} />
          <Route path="/store/:id" element={<StoreAddStock />} />

          {/* Pathology */}
          <Route path="/pathology" element={<Pathology />} />
          <Route
            path="/pathology/patient-progress/:id"
            element={<PathologyPatientProgress />}
          />
          <Route
            path="/pathology/add-report/:id"
            element={<PathologyAddReport />}
          />
          <Route
            path="/pathology/dr-approval"
            element={<PathologyDrApproval />}
          />

          {/* Pharmacy */}
          <Route path="/pharmacy" element={<Pharmacy />} />
          <Route
            path="/pharmacy/medicine-request/:trackingId"
            element={<PharmacyMedicineRequest />}
          />
          <Route
            path="/pharmacy/medicine-return/:trackingId"
            element={<PharmacyMedicineReturn />}
          />
          <Route
            path="/pharmacy/outsider/:patientId"
            element={<PharmacyOutsider />}
          />
          <Route
            path="/pharmacy/outsider"
            element={<PharmacyOutsider />}
          />
          <Route
            path="/pharmacy/outsiderReopen"
            element={<PharmacyOutsiderReopen />}
          />

          {/* Master */}
          <Route path="/master" element={<Master />} />
          <Route path="/master/item" element={<MasterItem />} />
          <Route path="/master/item/add" element={<MasterItemAdd />} />
          <Route path="/master/item/:id" element={<MasterItemAdd />} />
          <Route path="/master/department" element={<MasterDepartment />} />
          <Route path="/master/unit" element={<MasterUnit />} />
          <Route path="/master/category" element={<MasterCategory />} />
          <Route path="/master/sub-category" element={<MasterSubCategory />} />
          <Route path="/master/ward" element={<MasterWard />} />
          <Route path="/master/bed-category" element={<MasterBedCategory />} />
          <Route
            path="/master/bed-sub-category"
            element={<MasterBedSubCategory />}
          />
          <Route
            path="/master/bed-sub-category/bed-number-one"
            element={<MasterBedNumberOne />}
          />
          <Route
            path="/master/bed-sub-category/bed-number-two"
            element={<MasterBedNumberTwo />}
          />
          <Route path="/master/visit-type" element={<MasterVisitType />} />
          <Route path="/master/company" element={<MasterCompany />} />
          <Route path="/master/supplier" element={<MasterSupplier />} />
          <Route path="/master/supplier/add" element={<MasterSupplierAdd />} />
          <Route path="/master/supplier/:id" element={<MasterSupplierAdd />} />
          <Route path="/master/sharing" element={<MasterSharing />} />
          <Route path="/master/sharing/add" element={<MasterSharingAdd />} />
          <Route path="/master/sharing/edit/:id" element={<EditSharingTemplate />} />
          <Route
            path="/master/sharing/hospital-report"
            element={<MasterSharingHospitalReport />}
          />
          {/* <Route path="/master/sharing/:id" element={<MasterItemAdd />} /> */}
          <Route path="/master/contract" element={<MasterContract />} />
          <Route path="/master/contract/add" element={<MasterContractAdd />} />
          <Route path="/master/relief" element={<MasterRelief />} />
          <Route path="/master/relief/add" element={<MasterReliefAdd />} />
          <Route path="/master/policy" element={<MasterPolicy />} />
          <Route path="/master/policy/add" element={<MasterPolicyAdd />} />
          <Route path="/master/country" element={<MasterCountry />} />
          <Route path="/master/state" element={<MasterState />} />
          <Route path="/master/city" element={<MasterCity />} />
          <Route path="/master/relationship" element={<MasterRelationship />} />
          <Route path="/master/blood-group" element={<MasterBloodGroup />} />
          <Route
            path="/master/doctor-reference"
            element={<MasterDoctorReference />}
          />
          <Route
            path="/master/transaction-type"
            element={<MasterTransactionType />}
          />
          <Route
            path="/master/profile-edit"
            element={<MasterAdminProfileEdit />}
          />
          <Route path="/master/role" element={<MasterRole />} />
          <Route
            path="/master/dynamic-template"
            element={<MasterDynamicTemplate />}
          />
          <Route
            path="/master/dynamic-template/add/:templateId"
            element={<MasterAddDynamicTemplate />}
          />
          <Route
            path="/master/dynamic-template/add"
            element={<MasterAddDynamicTemplate />}
          />
          <Route path="/master/package" element={<MasterPackage />} />
          <Route path="/master/package/:id" element={<MasterPackageEdit />} />

          {/* Billing */}
          <Route path="/billing" element={<BillingList />} />
          <Route path="/billing/:id" element={<Billing />} />

          {/* Reports */}
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/cash-collection" element={<ReportsCashCollection />} />
          <Route
            path="/reports/summary-bill"
            element={<ReportsSummaryOfBill />}
          />
          <Route path="/reports/expense-report" element={<ReportsExpense />} />
          <Route
            path="/reports/expense-detail-statement"
            element={<ReportsExpenseDetailStatement />}
          />
          <Route
            path="/reports/advance-payment"
            element={<ReportsPatientAdvancePayment />}
          />
          <Route
            path="/reports/package-count-statement"
            element={<ReportsPackageCountSTatementIPD />}
          />
          <Route
            path="/reports/ipd-discharge-patient"
            element={<ReportsIPDDischargePatient />}
          />
          <Route
            path="/reports/ipd-patient-summary"
            element={<ReportsIPDPatientSummary />}
          />
          <Route
            path="/reports/patient-indent"
            element={<ReportsPatientIndentLedger />}
          />
          <Route
            path="/reports/patient-indent-return"
            element={<ReportsPatientIndentLedgerReturn />}
          />
          <Route
            path="/reports/patient-ward-issue"
            element={<ReportsPatientWardIssue />}
          />
          <Route
            path="/reports/cancel-payment"
            element={<ReportsCancelPayment />}
          />
          <Route path="/reports/collection" element={<ReportsCollection />} />
          <Route path="/reports/bill-detail" element={<ReportsBillDetail />} />
          <Route
            path="/reports/bed-occupancy"
            element={<ReportsBedOccupancy />}
          />
          <Route
            path="/reports/finance-dashboard"
            element={<ReportsFinanceDashboard />}
          />

          {/* Radiology  */}
          <Route path="/radiology" element={<Radiology />} />
          <Route
            path="/radiology/patient/:id"
            element={<RadiologyPatientAccept />}
          />

          {/* User */}
          <Route path="/user" element={<User />} />
          <Route path="/user/add" element={<UserAdd />} />
          <Route path="/user/:id" element={<UserAdd />} />
          <Route path="/user/:id/:type" element={<UserUnitRoleChange />} />

          {/* add relief */}
          <Route path="/add-relief" element={<AddRelief />} />

          {/* settings */}

          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
      <FloatingIcon />
    </BrowserRouter>
  );
};

export default App;
